class AppAuthApi {
    constructor(api) {
        this.api = api;
    }

    fetchActiveSessions() {
        return this.api.get(`users/current/sessions`);
    }

    logoutFromSession(sessionId) {
        return this.api.delete(`users/current/sessions/${sessionId}`);
    }
}

export default AppAuthApi;